import * as React from 'react';
import { useSelector } from 'react-redux';

import { TermsInfo } from '../../components/TermsInfo';
import { selectNewbuilding } from '../../selectors/newbuilding';
import { getPriceFrom, getPriceSquareFrom, getSaleDescription, getWorkTime } from './helpers';
import { ContactsBlockContainer } from './parts/ContactsBlockContainer';

export const TermsInfoContainer: React.VFC = () => {
  const newbuilding = useSelector(selectNewbuilding);

  const priceFrom = getPriceFrom(newbuilding);
  const priceSquareFrom = getPriceSquareFrom(newbuilding);
  const saleDescription = getSaleDescription(newbuilding);
  const workTime = getWorkTime(newbuilding);

  return (
    <TermsInfo
      contacts={<ContactsBlockContainer />}
      priceFrom={priceFrom}
      priceSquareFrom={priceSquareFrom}
      saleDescription={saleDescription}
      workTime={workTime}
    />
  );
};
